"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleComponents = exports.VehicleModels = void 0;
const autoscout24_health_score_1 = require("./autoscout24-health-score");
const autoscout24_price_rating_1 = require("./autoscout24-price-rating");
const check_1 = __importDefault(require("./check"));
const co2_class_1 = require("./co2-class");
const dummy_1 = __importDefault(require("./dummy"));
const exterior_color_tag_1 = require("./exterior-color-tag");
const image_preview_1 = require("./image-preview");
const interior_color_tag_1 = require("./interior-color-tag");
const inventory_state_1 = require("./inventory-state");
const mobile_price_rating_1 = require("./mobile-price-rating");
const model_description_1 = require("./model-description");
const online_tag_1 = require("./online-tag");
const translations_1 = require("./translations");
const vehicle_1 = require("./vehicle");
const vehicle_availability_1 = require("./vehicle-availability");
const vehicle_main_price_1 = require("./vehicle-main-price");
const vehicle_secondary_price_1 = require("./vehicle-secondary-price");
exports.VehicleModels = [
    vehicle_1.Vehicle,
    dummy_1.default,
];
exports.VehicleComponents = [
    model_description_1.VehicleModelDescription,
    translations_1.VehicleFuelType,
    translations_1.VehicleTransmissionShort,
    translations_1.VehicleDrivetrain,
    vehicle_availability_1.VehicleAvailability,
    inventory_state_1.VehicleInventoryState,
    vehicle_main_price_1.VehicleMainPrice,
    vehicle_secondary_price_1.VehicleSecondaryPrice,
    translations_1.VehicleTransmission,
    translations_1.VehicleInventoryStateShort,
    translations_1.VehicleAvailabilityShort,
    interior_color_tag_1.VehicleInteriorColor,
    translations_1.VehicleInteriorColorTranslation,
    translations_1.VehicleInteriorTypeTranslation,
    exterior_color_tag_1.VehicleExteriorColor,
    translations_1.VehicleExteriorColorTranslation,
    translations_1.VehicleUsageType,
    translations_1.VehicleCategory,
    translations_1.VehicleClass,
    translations_1.VehicleSlidingDoors,
    image_preview_1.VehicleImagePreview,
    check_1.default,
    co2_class_1.VehicleCo2Class,
    online_tag_1.VehicleOnlineTag,
    mobile_price_rating_1.MobilePriceRating,
    autoscout24_price_rating_1.Autoscout24PriceRating,
    autoscout24_health_score_1.Autoscout24HealthScore,
];
